/** Zone colour for a 0–100 emotional state index: <40 red, 40–60 amber, >60 green. */
export function emotionZone(index: number): { bar: string; text: string } {
  if (index < 40) return { bar: 'bg-destructive', text: 'text-destructive' }
  if (index <= 60) return { bar: 'bg-amber-500', text: 'text-amber-500' }
  return { bar: 'bg-emerald-500', text: 'text-emerald-500' }
}

/** Relative zone from a cohort percentile (0–100): bottom third red, middle amber, top green. */
export function percentileZone(p: number): { bar: string; text: string } {
  if (p < 34) return { bar: 'bg-destructive', text: 'text-destructive' }
  if (p <= 66) return { bar: 'bg-amber-500', text: 'text-amber-500' }
  return { bar: 'bg-emerald-500', text: 'text-emerald-500' }
}
